import instance from "./auth";

export const getAll = async (params) => {
    const {data} = await instance.get("/insights", {
        params,
    });
    return data;
}


